import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';

import './i18n';

const oldLocalStorage = localStorage.getItem('persist:root');

// * for compatibility with old versions of localStorage variables key
oldLocalStorage && localStorage.removeItem('persist:root');

console.log('APP_VERSION: ', '0.3.2');

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
